export type GarmentCategory = { id: string; label: string };

export type GarmentCategoryGroup = { id: string; label: string; items: GarmentCategory[] };

/** decision-data 品类标准 2-3 的二级。连衣裙没有二级，选项是连衣裙下的款式。 */
export const GARMENT_CATEGORY_GROUPS: GarmentCategoryGroup[] = [
  {
    "id": "tops",
    "label": "上装",
    "items": [
      {
        "id": "tops.t_shirts_polos",
        "label": "T恤与Polo衫"
      },
      {
        "id": "tops.shirts_blouses",
        "label": "衬衫与罩衫"
      },
      {
        "id": "tops.tank_tops_camisoles",
        "label": "背心与吊带上衣"
      },
      {
        "id": "tops.sweaters",
        "label": "毛衣与针织衫"
      },
      {
        "id": "tops.hoodies_sweatshirts",
        "label": "连帽衫与卫衣"
      },
      {
        "id": "tops.sports_tops",
        "label": "运动上衣"
      },
      {
        "id": "tops.bodysuits",
        "label": "连体上衣"
      }
    ]
  },
  {
    "id": "bottoms",
    "label": "下装",
    "items": [
      {
        "id": "bottoms.pants",
        "label": "长裤"
      },
      {
        "id": "bottoms.jeans",
        "label": "牛仔长裤"
      },
      {
        "id": "bottoms.leggings",
        "label": "紧身打底裤"
      },
      {
        "id": "bottoms.shorts",
        "label": "短裤"
      },
      {
        "id": "bottoms.skirts",
        "label": "半身裙"
      }
    ]
  },
  {
    "id": "outerwear",
    "label": "外套",
    "items": [
      {
        "id": "outerwear.jackets",
        "label": "夹克 / 短外套"
      },
      {
        "id": "outerwear.coats",
        "label": "大衣 / 长外套"
      },
      {
        "id": "outerwear.blazers",
        "label": "西装外套"
      },
      {
        "id": "outerwear.vests",
        "label": "马甲 / 外穿背心"
      }
    ]
  },
  {
    "id": "dresses",
    "label": "连衣裙",
    "items": [
      {
        "id": "dresses.shirt_dresses",
        "label": "衬衫裙"
      },
      {
        "id": "dresses.wrap_dresses",
        "label": "裹身连衣裙"
      },
      {
        "id": "dresses.slip_dresses",
        "label": "吊带裙"
      },
      {
        "id": "dresses.sweater_dresses",
        "label": "针织连衣裙"
      },
      {
        "id": "dresses.t_shirt_dresses",
        "label": "T恤裙"
      },
      {
        "id": "dresses.tiered_dresses",
        "label": "分层连衣裙"
      },
      {
        "id": "dresses.bodycon_dresses",
        "label": "紧身连衣裙"
      },
      {
        "id": "dresses.fit_and_flare_dresses",
        "label": "收腰伞裙"
      },
      {
        "id": "dresses.shift_dresses",
        "label": "直筒裙"
      },
      {
        "id": "dresses.other_dresses",
        "label": "其他连衣裙"
      }
    ]
  },
  {
    "id": "jumpsuits_rompers",
    "label": "连体服",
    "items": [
      {
        "id": "jumpsuits_rompers.jumpsuits",
        "label": "长裤型连体衣"
      },
      {
        "id": "jumpsuits_rompers.rompers",
        "label": "短裤型连体衣"
      },
      {
        "id": "jumpsuits_rompers.overalls",
        "label": "背带裤"
      }
    ]
  },
  {
    "id": "shoes",
    "label": "鞋履",
    "items": [
      {
        "id": "shoes.sneakers",
        "label": "运动鞋和休闲运动鞋"
      },
      {
        "id": "shoes.boots",
        "label": "靴子"
      },
      {
        "id": "shoes.sandals",
        "label": "凉鞋"
      },
      {
        "id": "shoes.heels",
        "label": "高跟鞋"
      },
      {
        "id": "shoes.flats",
        "label": "平底鞋"
      },
      {
        "id": "shoes.loafers",
        "label": "乐福鞋"
      },
      {
        "id": "shoes.mules_clogs",
        "label": "穆勒鞋和木屐式鞋"
      },
      {
        "id": "shoes.oxfords_derbies",
        "label": "牛津鞋与德比鞋"
      },
      {
        "id": "shoes.other_shoes",
        "label": "其他鞋履"
      }
    ]
  },
  {
    "id": "jewelry_watches",
    "label": "首饰与腕表",
    "items": [
      {
        "id": "jewelry_watches.necklaces",
        "label": "项链"
      },
      {
        "id": "jewelry_watches.earrings",
        "label": "耳饰"
      },
      {
        "id": "jewelry_watches.rings",
        "label": "戒指"
      },
      {
        "id": "jewelry_watches.bracelets",
        "label": "手链 / 手镯"
      },
      {
        "id": "jewelry_watches.watches",
        "label": "腕表"
      }
    ]
  },
  {
    "id": "bags",
    "label": "包袋",
    "items": [
      {
        "id": "bags.shoulder_bags",
        "label": "单肩包"
      },
      {
        "id": "bags.crossbody_bags",
        "label": "斜挎包"
      },
      {
        "id": "bags.top_handle_bags",
        "label": "顶部手提包"
      },
      {
        "id": "bags.tote_bags",
        "label": "托特包"
      },
      {
        "id": "bags.backpacks",
        "label": "背包"
      },
      {
        "id": "bags.waist_bags",
        "label": "腰包"
      },
      {
        "id": "bags.luggage",
        "label": "行李箱"
      },
      {
        "id": "bags.duffel_bags",
        "label": "圆筒包"
      },
      {
        "id": "bags.clutches_wristlet_bags",
        "label": "手拿包 / 腕包"
      },
      {
        "id": "bags.wallets_small_cases",
        "label": "钱包与小型收纳"
      },
      {
        "id": "bags.other",
        "label": "其他包袋"
      }
    ]
  },
  {
    "id": "accessories",
    "label": "配饰",
    "items": [
      {
        "id": "accessories.belts",
        "label": "腰带"
      },
      {
        "id": "accessories.scarves",
        "label": "围巾 / 丝巾"
      },
      {
        "id": "accessories.hats",
        "label": "帽子"
      },
      {
        "id": "accessories.phone_cases_technology",
        "label": "手机壳和科技配件"
      },
      {
        "id": "accessories.sunglasses_eyewear",
        "label": "太阳镜与眼镜"
      },
      {
        "id": "accessories.ties_bow_ties",
        "label": "领带与领结"
      },
      {
        "id": "accessories.gloves",
        "label": "手套"
      },
      {
        "id": "accessories.other_accessories",
        "label": "其他配饰"
      }
    ]
  },
  {
    "id": "intimates_hosiery",
    "label": "贴身衣物与袜类",
    "items": [
      {
        "id": "intimates_hosiery.sleepwear_loungewear",
        "label": "睡衣与家居服"
      },
      {
        "id": "intimates_hosiery.thermal_underwear",
        "label": "保暖内衣"
      },
      {
        "id": "intimates_hosiery.bras_bralettes",
        "label": "文胸"
      },
      {
        "id": "intimates_hosiery.underpants",
        "label": "内裤"
      },
      {
        "id": "intimates_hosiery.socks",
        "label": "袜子"
      },
      {
        "id": "intimates_hosiery.tights_hosiery",
        "label": "连裤袜与丝袜"
      }
    ]
  },
  {
    "id": "swimwear_beachwear",
    "label": "泳装与海滩服饰",
    "items": [
      {
        "id": "swimwear_beachwear.bikinis",
        "label": "比基尼套装"
      },
      {
        "id": "swimwear_beachwear.one_pieces",
        "label": "连体泳衣"
      },
      {
        "id": "swimwear_beachwear.cover_ups",
        "label": "罩衫（裙）"
      },
      {
        "id": "swimwear_beachwear.swim_bottoms",
        "label": "游泳裤"
      }
    ]
  }
];
